import {EntityWithId} from "../baseEntities";



export enum SolicitationFilePostFields { 
    OperationSolicitationId = 'idSolicitudOperacion',
    File = 'file'
}


export interface SolicitationFilePost extends FileBase{
    [SolicitationFilePostFields.OperationSolicitationId]: number | null,
    [SolicitationFilePostFields.File]: File,
}

export enum FileBaseFields {
    FileTypeCode = 'codArchivoTipo',
    FilePathCode = 'codPathFile',
    FilePathPrefix = 'pathFilePrefijo',
    FileDesc = 'descArchivo',
    HasPhysicalFile = 'tieneArchivoFisico',
    Observation = 'observacion',
    RegisterUserId = 'idUsuarioAlta',
    BeginDate = 'fechaAlta',
    ExpirationDate = 'fechaVencimiento',

    FileTypeDesc = 'descArchivoTipo',
    PhysicalFilePath = 'pathFisicoArchivo',
    VirtualFilePath = 'pathVirtualArchivo',
}

export interface FileBase extends EntityWithId<number> {
    [FileBaseFields.FileTypeCode]: number;
    [FileBaseFields.FilePathCode]?: number;
    [FileBaseFields.FilePathPrefix]: string;
    [FileBaseFields.FileDesc]: string;
    [FileBaseFields.HasPhysicalFile]: boolean;
    [FileBaseFields.Observation]: string;
    [FileBaseFields.RegisterUserId]: number;
    [FileBaseFields.BeginDate]: Date;
    [FileBaseFields.ExpirationDate]?: Date;

    [FileBaseFields.FileTypeDesc]: string;
    [FileBaseFields.PhysicalFilePath]: string;
    [FileBaseFields.VirtualFilePath]: string;
}

export enum SolicitationFileViewDTOFields {
    OperationSolicitationId = 'idSolicitudOperacion',
    SolicitationId = 'idSolicitud'
}

export interface FileBaseInsert extends FileBase {
    [SolicitationFilePostFields.File]?: File;
}



export interface SolicitationFileViewDTO extends FileBase {
    [SolicitationFileViewDTOFields.OperationSolicitationId]: number,
    [SolicitationFileViewDTOFields.SolicitationId]: number
}